import React from 'react'

const Social = () => {
  return (
    <div className='home-social'>
      <a href="https://www.linkedin.com/in/mark%C3%A9ta-gr%C3%A1cov%C3%A1" className="home-social-icon" target="_blank" rel="noopener noreferrer">
        <i class="uil uil-linkedin-alt"></i>
      </a>
      <a href="https://github.com/MarketaG" className="home-social-icon" target="_blank" rel="noopener noreferrer">
        <i class="uil uil-github-alt"></i>
      </a>
    </div>
  )
}

export default Social